// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__3E4aK","logo":"Menu_logo__1KcWt","mainMenu":"Menu_mainMenu__1zgFu","feedback":"Menu_feedback__XC1XP"};